import { Routes } from '@angular/router';
import { faGarage, faWarehouse, faCarBolt, faSquareList } from '@fortawesome/pro-duotone-svg-icons';
import { genericResolver } from '@nittenapps/api';
import { dirtyGuard } from '@nittenapps/common';
import { NavItem } from '@nittenapps/components';

export const SALVAGES_ITEMS: NavItem[] = [
  {
    label: 'Salvamentos',
    icon: faGarage,
    iconSet: 'duo',
    roles: ['salvages'],
    children: [
      {
        label: 'Pérdida total',
        icon: faCarBolt,
        iconSet: 'duo',
        roles: ['salvages'],
        routerLink: ['salvages', 'total-loss'],
      },
      {
        label: 'Inventario de Salvamentos',
        icon: faSquareList,
        iconSet: 'duo',
        roles: ['salvages'],
        routerLink: ['salvages', 'inventory'],
      },
      {
        label: 'Deudor de Salvamentos',
        icon: faWarehouse,
        iconSet: 'duo',
        roles: ['salvages'],
        routerLink: ['salvages', 'debtor'],
      },
    ],
  },
];

export const ROUTES: Routes = [
  {
    path: 'debtor',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Deudor de Salvamentos',
      roles: ['salvages'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./debtor/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./debtor/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: genericResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model?.number || 'Nuevo'}` },
        },
      },
    ],
  },
  {
    path: 'inventory',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Inventario de Salvamentos',
      roles: ['salvages'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./inventory/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./inventory/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: genericResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model?.number || 'Nuevo'}` },
        },
      },
    ],
  },
  {
    path: 'total-loss',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Pérdida total',
      roles: ['salvages'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./total-loss/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./total-loss/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: genericResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model?.number || 'Nuevo'}` },
        },
      },
    ],
  },
];
